import React from "react";
import withShipment from "../../../withShipment";

import './FTLCostsTable.css';
import TablePage from "../../global/Table/TablePage";
import { Box, FormControl, InputLabel, MenuItem, Select, TableCell } from '@mui/material';
import {Layout} from "../../global/Table/TablePageHelpers/LayoutObject";
import {
    DEFAULT_SORT_BY_HEAD_CELL,
    FTL_COST_PAGE_NAME,
    LIST_FTL_COST_CELLS,
    ROWS_PER_PAGE_LABEL
} from "../constants";
import TopToolbar from "../../global/subcomponents/topToolbar/TopToolbar";
import LocationSelectBox from "../../global/subcomponents/locationSelectBox/LocationSelectBox";
import { BACK } from '../../invoices/carrierInvoices/constants';
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace';
import SettingsIcon from '@material-ui/icons/Settings';
import { IconButton, TextField, Tooltip } from '@material-ui/core';
import InputAdornment from '@material-ui/core/InputAdornment';
import {
  FTL_COST_PART1,
  FTL_COST_PART2,
  OPTIONS,
  SHIPPING_COST_INFO,
} from '../../automationrules/AutomationSettings/constants';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import Autocomplete from '@material-ui/lab/Autocomplete';

class FTLCostsTable extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            tableEvents: [],
            isSettingPage: false,
            selectedStatus: false,
            otherCostStatus: false,
            productCostFromDate: '1',
            boxCostFromDate: '1',
            ftlCostFromDate: '',
            otherCostText: '0.00',
            percentageCostText: '',
            dollarCostText: '',
            referralFeeText: '15',
            boxAverageCost: '',
            currencyRates:[],
            defaultCurrency: "",
            shippingCostFromDate: '1',
            locations: [],
            selectedLocation: "All",
            selectedCurrency: "All",
        }
    }

     componentDidMount() {
        this.updateState()
        this.updateLocations(this.props.availableLocations);
  }

    componentDidUpdate(prevProps: Readonly<P>, prevState: Readonly<S>, snapshot: SS) {
        if (prevProps.availableLocations !== this.props.availableLocations) {
           this.updateLocations(this.props.availableLocations);
        }

        if(prevProps.automationSettings !== this.props.automationSettings) {
            this.updateState()
        }
    }

    updateLocations = (availableLocations) => {
      if (!availableLocations) return;
      const locations = [
        { name: 'All', id: 'All' },
        ...availableLocations
          .filter(loc => loc.enabled === true)
          .map(loc => ({ name: loc.name, id: loc.shipAddressId })) // store shipAddressId
      ];
      this.setState({ locations });
    }

    handleCurrencyChange = (event) => {
        this.setState({ selectedCurrency: event.target.value })
    }

    handleLocationChange = (event) => {
        this.setState({ selectedLocation: event.target.value })
    }

    setIsSettingPage = (bool) => {
      this.setState({ isSettingPage: bool });
    };

    updateHandler = () => {
        let inputObject = {};
        let boxDateRange = {};
        let ftlDateRange = {};
        let productDateRange = {};
        let shippingDateRange = {};
        productDateRange["fromDate"] = this.state.productCostFromDate;
        boxDateRange["fromDate"] = this.state.boxCostFromDate;
        ftlDateRange["fromDate"] = this.state.ftlCostFromDate;
        shippingDateRange["fromDate"] = this.state.shippingCostFromDate;
        inputObject["accountForProfitOrLoss"] = this.state.selectedStatus;
        inputObject["productCostDateRange"] = productDateRange;
        inputObject["boxCostDateRange"] = boxDateRange;
        inputObject["ftlCostDateRange"] = ftlDateRange;
        inputObject["shippingCostDateRange"] = shippingDateRange;
        inputObject["otherCosts"] = this.state.otherCostStatus;
        inputObject["otherCostText"] = this.state.otherCostText;
        inputObject["referralFee"] = this.state.referralFeeText;
        inputObject["currencyRates"] = this.state.currencyRates;
        inputObject["defaultCurrency"] = this.state.defaultCurrency;
        this.props.updateCompany({
            companyId: this.props.user.company,
            automationSetting: inputObject,
        });
    }

    updateState = () => {
        this.setState({
            selectedStatus: this.props?.automationSettings?.accountForProfitOrLoss === undefined ? false : this.props?.automationSettings?.accountForProfitOrLoss,
            otherCostStatus: this.props?.automationSettings?.otherCosts === undefined ? false : this.props?.automationSettings?.otherCosts,
            productCostFromDate: this.props?.automationSettings?.productCostDateRange?.fromDate === undefined ? "1" : this.props?.automationSettings?.productCostDateRange?.fromDate,
            boxCostFromDate: this.props?.automationSettings?.boxCostDateRange?.fromDate === undefined ? "1" : this.props?.automationSettings?.boxCostDateRange?.fromDate,
            ftlCostFromDate: this.props?.automationSettings?.ftlCostDateRange?.fromDate === undefined ? "" : this.props?.automationSettings?.ftlCostDateRange?.fromDate,
            shippingCostFromDate: this.props?.automationSettings?.shippingCostDateRange?.fromDate === undefined ? "" : this.props?.automationSettings?.shippingCostDateRange?.fromDate,
            otherCostText: this.props?.automationSettings?.otherCostText === undefined ? "0.00" : this.props.automationSettings?.otherCostText,
            referralFeeText: this.props?.automationSettings?.referralFee === undefined ? "15" : this.props?.automationSettings?.referralFee,
            currencyRates: this.props?.automationSettings?.currencyRates === undefined ? [] : this.props?.automationSettings?.currencyRates,
            defaultCurrency: this.props?.automationSettings?.defaultCurrency === undefined ? [] : this.props?.automationSettings?.defaultCurrency
        });
    }

    handleFTLDateChange = async (date, fromOrTo) => {
      if (fromOrTo === 'from') {
        await this.setState({
          ftlCostFromDate: date,
        });
      }
      this.updateHandler();
    };


    getTableHeaders = () => {
        let headers = []
        headers.push(Layout.columnHead(null,null,null))
        LIST_FTL_COST_CELLS.forEach((headCell) => {
            headers.push(Layout.columnHead(headCell.label, headCell.id, "left"))
        })
        return headers
    }

    tableRow = (row, index) => {
        return <React.Fragment>
            <TableCell />
            <TableCell align="left" style={{paddingLeft: 5}}> {row?.shortcode} </TableCell>
            <TableCell align="left"> {row?.averageCost ? "$" + parseFloat(row?.averageCost.toString()).toFixed(2) : ""} </TableCell>
            <TableCell align="left"> {row?.currency} </TableCell>
        </React.Fragment>
    }

    searchStrings = (row) => {
        return [row.shortcode, row.averageCost, row.currency]
    }

    userHasAutomationSettingPermission = () => {
       const userRoutes = this.props.user?.routes || []
       return userRoutes.includes('automation-settings')
    }

    render() {

        const currency = ['All','CAD', 'USD']

        const filteredRows = this.props.tableRows.filter((row) => {
          const loc = this.state.selectedLocation;
          const curr = this.state.selectedCurrency; // assuming you store it here

          // --- LOCATION FILTER ---
          if (!loc || loc === '' || loc === 'All') {
            if (row.type !== 'GLOBAL') return false;
          } else if (row.shipAddressId  !== loc) {
            return false;
          }

          // --- CURRENCY FILTER ---
          if (curr === 'All') {
            return row.currency === 'CAD' || row.currency === 'USD';
          } else {
            return row.currency === curr;
          }
        });

        const menuItems = [];

        if (this.state.isSettingPage) {
          menuItems.push({
            title: 'Back',
            icon: <KeyboardBackspaceIcon />,
            onClick: () => {
              this.setIsSettingPage(false);
            },
          });
        } else if (this.userHasAutomationSettingPermission()) {
          menuItems.push({
            title: 'Settings',
            icon: <SettingsIcon />,
            onClick: () => {
              this.setIsSettingPage(true);
            },
          });
        }

        return (
            <React.Fragment>
                <TopToolbar
                    pageName={this.state.isSettingPage ? 'Settings' : FTL_COST_PAGE_NAME}
                    menuItems={menuItems}
                />

                 {this.state.isSettingPage ? (
                   <div style={{ marginTop: '24px', marginLeft: '24px' }}>
                     <div className="other-margin">
                       <div style={{ display: 'flex', alignItems: 'center' }}>
                         <TextField
                           label="FTL Cost"
                           InputProps={{
                             disabled: true,
                             endAdornment: (
                               <InputAdornment position="end">
                                 <Tooltip
                                   enterTouchDelay={0}
                                   leaveTouchDelay={30000}
                                   enterDelay={400}
                                   // leaveDelay={1000000} // for testing purposes
                                   title={
                                     <React.Fragment>
                                       <p>{FTL_COST_PART1}</p>
                                       <p>{FTL_COST_PART2}</p>
                                     </React.Fragment>
                                   }
                                 >
                                   <IconButton aria-label="info">
                                     <InfoOutlinedIcon
                                       variant="outlined"
                                       fontSize="small"
                                     />
                                   </IconButton>
                                 </Tooltip>
                               </InputAdornment>
                             ),
                           }}
                           variant="outlined"
                           style={{
                             marginBottom: '5px',
                             maxWidth: '175px',
                             minWidth: '175px',
                           }}
                           InputLabelProps={{ className: 'box-label' }}
                         />
                       </div>
                       <div className="vl"></div>
                       <div
                         style={{
                           display: 'flex',
                           flexDirection: 'column',
                           alignItems: 'center',
                         }}
                       >
                         <Autocomplete
                           options={OPTIONS}
                           getOptionLabel={(option) => option.label}
                           className="date-box"
                           name="addTag"
                            onChange={(event, value) => {
                              if (value) {
                                this.handleFTLDateChange(value.id, 'from');
                              } else {
                                this.handleFTLDateChange(null, 'from');
                              }
                            }}
                            value={OPTIONS.find(
                              (opt) => opt.id === this.state.ftlCostFromDate
                            ) || null}
                           renderInput={(params) => (
                             <div>
                               <TextField
                                 {...params}
                                 label="Average Over"
                                 InputLabelProps={{ shrink: true }}
                                 variant="outlined"
                                 name="addTag"
                               />
                             </div>
                           )}
                         />
                       </div>
                     </div>
                   </div>
                 ) : (
                 <>
                     <Box className="box-shipping-cost">

                       <FormControl variant="outlined" className="form-control">
                          <InputLabel id="currency-label">Location</InputLabel>
                          <Select
                            className="form-shipping-select"
                            labelId="localion-label"
                            value={this.state.selectedLocation}
                            onChange={this.handleLocationChange}
                            label="Location"
                          >
                            {this.state.locations.map((loc) => (
                             <MenuItem key={loc.id} value={loc.id}>
                              {loc.name}
                             </MenuItem>
                            ))}
                          </Select>
                        </FormControl>

                       <FormControl variant="outlined" className="form-control">
                          <InputLabel id="currency-label">Currency</InputLabel>
                          <Select
                            className="form-shipping-select"
                            labelId="currency-label"
                            value={this.state.selectedCurrency}
                            onChange={this.handleCurrencyChange}
                            label="Currency"
                          >
                            {currency.map((currency) => (
                              <MenuItem key={currency} value={currency}>
                                {currency}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                     </Box>
                     <div className="table-page-shipping-cost">

                       <TablePage
                         tableName="FTLCostsTable"
                         eventsVariable={this.state.tableEvents}
                         setEventsVariable={(newState) => {
                           this.setState({ tableEvents: newState })
                         }}
                         tableRows={filteredRows}
                         // tableRows={this.props.tableRows.filter(
                         //   row => row.shipAddressId === this.state.selectedLocation
                         // )}
                         tableColumnHeads={this.getTableHeaders()}
                         tableRow={this.tableRow}
                         paginationText={ROWS_PER_PAGE_LABEL}
                         defaultSortBy={DEFAULT_SORT_BY_HEAD_CELL}
                         hasSearchField
                         searchStrings={this.searchStrings}
                         applyFilterDropdownChangesImmediately
                       />
                       </div>
                   </>
                   )
                 }
            </React.Fragment>
        )
    }
}

const mapStateToProps = (state) => ({})

const actionCreators = {}
FTLCostsTable.defaultProps = {
  locations: []
}

export default withShipment({
  mapStateToProps,
  actionCreators
}, FTLCostsTable);